import React from 'react'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const ProfileView = () => {
  const { t } = useLang()
  const p = t.acct.profile

  const tabs = [
    { id: "you",   label: p.your_info, active: true },
    { id: "addr",  label: p.addresses },
    { id: "notif", label: p.notifs },
    { id: "pay",   label: p.payment },
    { id: "lang",  label: p.language },
    { id: "sec",   label: p.security },
    { id: "data",  label: p.data_privacy },
  ]

  const notifRows = [
    { name: p.pro_eta,            desc: p.pro_eta_desc,            states: [true, false, true, false] },
    { name: p.pro_arrived,        desc: p.pro_arrived_desc,        states: [true, false, true, false] },
    { name: p.visit_complete,     desc: p.visit_complete_desc,     states: [false, true, true, false] },
    { name: p.reminder_24,        desc: "",                        states: [true, true, false, false] },
    { name: p.recommended_items,  desc: p.recommended_items_desc,  states: [false, true, false, false] },
    { name: p.emergency_updates,  desc: p.emergency_updates_desc,  states: [true, false, true, true] },
    { name: p.membership_billing, desc: p.membership_billing_desc, states: [false, true, false, false] },
    { name: p.tips_digest,        desc: p.tips_digest_desc,        states: [false, false, false, false] },
  ]

  return (
    <div className="app-shell">
      <Sidebar active="profile"/>
      <div className="main-pane">
        <Topbar crumbs={[p.title + " & " + p.notifs]}/>
        <div className="content">
          <div style={{ display: "grid", gridTemplateColumns: "240px 1fr", gap: 32 }}>
            {/* Side tabs */}
            <div style={{ display: "flex", flexDirection: "column", gap: 4, position: "sticky", top: 100, alignSelf: "start" }}>
              <div className="kicker" style={{ marginBottom: 10, padding: "0 12px" }}>{p.settings_label}</div>
              {tabs.map(tab => (
                <div key={tab.id} style={{
                  padding: "9px 12px", borderRadius: 8, fontSize: 13, cursor: "pointer",
                  background: tab.active ? "rgba(194,85,45,0.1)" : "transparent",
                  color: tab.active ? "var(--terracotta)" : "var(--cocoa)",
                  fontWeight: tab.active ? 600 : 400,
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                }}>
                  {tab.label} {tab.active && <Ico.chev/>}
                </div>
              ))}
              <div style={{ height: 1, background: "var(--line)", margin: "12px 0" }}/>
              <div style={{ padding: "9px 12px", color: "var(--terracotta)", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                <Ico.signout width="14" height="14"/> {p.sign_out}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              <h1 className="h-display" style={{ fontSize: 32, margin: 0 }}>
                {p.your_info}
              </h1>

              <div className="tile" style={{ padding: 22 }}>
                <div style={{ display: "flex", gap: 18, alignItems: "center", marginBottom: 22 }}>
                  <div style={{ width: 64, height: 64, borderRadius: "50%", background: "var(--terracotta)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, fontWeight: 600 }}>ML</div>
                  <div style={{ flex: 1 }}>
                    <div className="h-display" style={{ fontSize: 20 }}>Maria Lopez</div>
                    <div className="font-mono" style={{ fontSize: 11, color: "var(--muted)" }}>{p.member_no}</div>
                  </div>
                  <button className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 12 }}>{p.change_photo}</button>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                  <div>
                    <label className="auth-input-label">{p.first_name}</label>
                    <input className="auth-input" defaultValue="Maria"/>
                  </div>
                  <div>
                    <label className="auth-input-label">{p.last_name}</label>
                    <input className="auth-input" defaultValue="Lopez"/>
                  </div>
                  <div>
                    <label className="auth-input-label">{p.email}</label>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <input className="auth-input" defaultValue="maria@email.com"/>
                      <span className="status-pill pill-live" style={{ padding: "3px 8px" }}><Ico.check width="10" height="10"/>{p.verified}</span>
                    </div>
                  </div>
                  <div>
                    <label className="auth-input-label">{p.phone}</label>
                    <input className="auth-input" defaultValue="(305) 555-0142"/>
                  </div>
                </div>
              </div>

              {/* Notifications */}
              <div className="tile" style={{ padding: 22 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{p.how_we_reach}</h3>
                  <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{p.saved_ago}</span>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto auto auto", gap: 12, alignItems: "center" }}>
                  <div/>
                  {[p.text, p.email_col, p.push, p.call].map(h => <div key={h} className="font-mono" style={{ fontSize: 9, color: "var(--muted)", textAlign: "center" }}>{h}</div>)}

                  {notifRows.map((row, i) => (
                    <React.Fragment key={i}>
                      <div style={{ borderTop: "1px solid var(--line)", paddingTop: 12, paddingBottom: 6 }}>
                        <div style={{ fontSize: 14 }}>{row.name}</div>
                        {row.desc && <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>{row.desc}</div>}
                      </div>
                      {row.states.map((s, j) => (
                        <div key={j} style={{ borderTop: "1px solid var(--line)", display: "flex", justifyContent: "center", paddingTop: 14, paddingBottom: 6 }}>
                          <div className={`toggle ${s ? "on" : ""}`}/>
                        </div>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              {/* Quiet hours */}
              <div className="tile" style={{ padding: 22 }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: "0 0 4px" }}>{p.quiet_hours}</h3>
                <p style={{ fontSize: 13, color: "var(--muted)", margin: "0 0 16px" }}>{p.quiet_hours_blurb}</p>
                <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                  <div className="checkbox-pill on">9:00 PM → 8:00 AM</div>
                  <div className="font-mono" style={{ fontSize: 11, color: "var(--muted)" }}>{p.mon_fri}</div>
                  <div className="checkbox-pill">10:00 PM → 9:00 AM</div>
                  <div className="font-mono" style={{ fontSize: 11, color: "var(--muted)" }}>{p.sat} · {p.sun}</div>
                </div>
              </div>

              {/* Danger zone */}
              <div className="tile" style={{ padding: 22, borderColor: "rgba(194,85,45,0.3)", background: "rgba(194,85,45,0.04)" }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: "0 0 4px", color: "var(--terracotta-deep)" }}>{p.account_actions}</h3>
                <p style={{ fontSize: 13, color: "var(--muted)", margin: "0 0 16px" }}>{p.account_actions_blurb}</p>
                <div style={{ display: "flex", gap: 10 }}>
                  <button className="btn btn-ghost" style={{ padding: "9px 14px", fontSize: 12 }}>{p.pause_membership}</button>
                  <button className="btn" style={{ padding: "9px 14px", fontSize: 12, color: "var(--terracotta-deep)", background: "transparent", border: "1.5px solid var(--terracotta-deep)" }}>{p.delete_account}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ProfilePage() {
  return <ProfileView />
}
